module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6nlk1"))).then(() => parcelRequire('2KbAe'));